import styled, { keyframes } from 'styled-components';
import backgroundImg from '../../assets/images/bg2.png';

const getFromDown = keyframes`
  0%{
    transform: translate(0%,100%) ;
    opacity:0
  }
  90%{
    transform: translate(0%,0%) ;
    opacity:.9
  }
  100%{
    transform: translate(0%,0%) ;
    opacity:1
  }
`;


export const Warper = styled.div`
display: flex;
flex-direction: row;
align-items: center;
justify-content: center;
height: 100vh;
.for-logo{
  animation:none;
  gap:20%;

}
`;
export const LoginImage = styled.div`
width:62%;
height:100vh;
transform:translate(0,0)!important;
animation:none;
img{
  width:100%;
  height:100%
}
`;
export const LoginDiv = styled.div`
  width:38%;
  .formContainer{
    width: 69%;
    border-radius: 0.2rem;
    margin:0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 87vh;
  }
`;

export const Mask = styled.div`
  width: 100%;
  height: 100%;
  filter: brightness(15);
  opacity: 0.2;
`;

export const Logo = styled.img`
  z-index: 3;
  width: 18vw;
  margin-bottom: 1.5em;
`;

export const FomrDiv = styled.div`
  color: #000;
  z-index: 3;
  width:100%;
`;
export const Title = styled.p`
  font-size: 1.8rem;
  font-weight: bold;
  width: 100%;
    color: #504C33;
    margin: 1.5rem auto 0;
  z-index: 3;
`;

export const Label = styled.label`
  margin: 10px 60px 9px 4px;
  font-size: 14px;
  font-weight: 400;
`;

export const ForgotPassword = styled.a`
  cursor: pointer;
  text-align: right;
  font-size: 14px;
  color: #fff;
  text-decoration: none;
  :hover {
    text-decoration: none;
  }
  :visited {
    color: #000;
    text-decoration: none;
  }
  margin-bottom: 1rem;
`;

export const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
